// extracted by mini-css-extract-plugin
export default {"textArea":"LongText_textArea__3TtJu","content":"LongText_content__Gt5lm","copyButton":"LongText_copyButton__3uq73"};